import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import Paper from '../../atoms/Paper'
import ScrollView from '../../atoms/ScrollView'
import VerificationIncentiveTemplate from '../../templates/VerificationIncentiveTemplate'
import medias from '../../../util/medias'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  ${medias.medium`
    margin: 0;
  `}
`

export const VerificationIncentivePage = ({
  onBounceClick,
  onVerifyPhoneClick,
  onActivateWalletClick,
  onVerificationCompleted,
}) => (
  <ScrollView>
    <Content>
      <Paper>
        <VerificationIncentiveTemplate
          onActivateWalletClick={onActivateWalletClick}
          onBounceClick={onBounceClick}
          onVerificationCompleted={onVerificationCompleted}
          onVerifyPhoneClick={onVerifyPhoneClick}
        />
      </Paper>
    </Content>
  </ScrollView>
)

VerificationIncentivePage.propTypes = {
  onActivateWalletClick: PropTypes.func.isRequired,
  onBounceClick: PropTypes.func.isRequired,
  onVerificationCompleted: PropTypes.func.isRequired,
  onVerifyPhoneClick: PropTypes.func.isRequired,
}
